<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button v-if="addPower" type="primary" icon="el-icon-plus" size="small" @click="setAddAndModify(false)">新建角色</el-button>
        </li>
        <li>
          <span>角色名称：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryRoleName" @input="getList"></el-input>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="ListMain-table-expand">
              <el-form-item label="创建时间">
                <span>{{ props.row.createTime }}</span>
              </el-form-item>
              <el-form-item label="最后修改时间">
                <span>{{ props.row.updateTime }}</span>
              </el-form-item>
              <el-form-item label="修改人">
                <span>{{ props.row.modifier }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{ props.row.remark }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="roleName" label="角色名称" min-width="150px"></el-table-column>
        <el-table-column v-if="deletePower || modifyPower" label="操作" min-width="150px">
          <template slot-scope="scope">
            <el-button v-if="modifyPower" type="text" size="small" @click="setAddAndModify(tableData[scope.$index])">修改</el-button>
            <el-button v-if="deletePower" type="text" size="small" style="color: #F56C6C" @click="setDelete(tableData[scope.$index])">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'List',
  components: {
    Pagination
  },
  data () {
    return {
      isLoading: true,
      activeValue: 1,
      inactiveValue: 0,
      thisModule: [],
      tableData: [],
      addPower: false,
      deletePower: false,
      modifyPower: false,
      queryRoleName: ''
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.user.children.role.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      let power = powers[300].powerValue
      // 新增
      if ((power & thisModule.add.power) === thisModule.add.power) {
        this.addPower = true
      }
      // 删除
      if ((power & thisModule.delete.power) === thisModule.delete.power) {
        this.deletePower = true
      }
      // 修改
      if ((power & thisModule.modify.power) === thisModule.modify.power) {
        this.modifyPower = true
      }
    })
    // 缓存模块配置
    this.thisModule = thisModule
    // 判断临时缓存是否存在
    this.myOption.getScreenData(this, 'screen-role')
    // 调用获取列表函数
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.api,
        data: this.qs.stringify({
          roleName: this.queryRoleName,
          startPage: this.$store.state.user.currentPage,
          pageSize: this.$store.state.user.pageSize
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.tableData = res.data.data.data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 新增和修改
    setAddAndModify (data) {
      if (data) {
        this.$store.dispatch('SetEditId', {id: data.roleId, copy: false})
      }
      let param = {}
      if (this.queryRoleName !== '') {
        param.queryUserName = this.queryUserName
      }
      if (this.$store.state.user.currentPage !== 1) {
        param.startPage = this.$store.state.user.currentPage
      }
      if (this.$store.state.user.pageSize !== 10) {
        param.startPage = this.$store.state.user.pageSize
      }
      if (Object.keys(param).length > 0) {
        window.sessionStorage.setItem('screen-role', JSON.stringify(param))
      }
      this.myOption.switchListAndEdit(this, false)
    },
    // 删除
    setDelete (param) {
      this.$confirm(`是否删除 "${param.roleName}" 角色`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.delete.id
          },
          url: this.myOption.requestUrl + this.thisModule.delete.api,
          data: this.qs.stringify({
            roleIds: param.roleId
          })
        }).then(res => {
          const code = res.data.code
          if (res.data.code === 200) {
            this.$message.success('删除角色成功')
            this.getList()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/role/List.vue